module.exports = __webpack_public_path__ + "images/halloween_lp/step3-NumberIcon_0601812ef73e2d802c28d22db0fc4f53.png";